











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ListItem extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly value!: unknown;
}
